import { Colours } from "@flightpath/coreui/dist/ui/hr";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { Button, ButtonTypes } from "../../../components/ui/Button";
import { Hr } from "../../../components/ui/Hr";
import { Icon, IconSymbols } from "../../../components/ui/Icon";
import { Animations } from "../../../core/util/Animations";
import "./_sidenav.scss";
import { DashboardNavItems, ProjectNavItems } from "./SideNavItems";
import { IF } from "../../../components/hoc/If";
import { SettingsNavigation } from "./SettingsNav";
import logo from "../../../components/widgets/navigation/logos/logo-reversed-colour.svg";
import miniLogo from "../../../components/widgets/navigation/logos/logo-mini.svg";
import { Enums } from "../../../enums";
import { useOrganisationSettingsContext } from "../../../contexts/organisationSettings/OrganisationSettingsContext";

export const SideNav: React.FC<{ onExpandedToggle: (isExpanded: boolean) => void }> = observer(props => {
  const settingsContext = useOrganisationSettingsContext();
  const { projectId } = useParams();
  const [isExpanded, setIsExpanded] = useState<boolean>(() => {
    const stored = localStorage.getItem("insight-sidenav-expanded");
    return stored === null || stored === "true";
  });

  useEffect(() => {
    const stored = localStorage.getItem("insight-sidenav-expanded");
    setIsExpanded(stored === null || stored === "true");
  }, []);

  const isAIChatEnabled = settingsContext.isAIChatEnabled();

  return (
    <div className={`side-nav ${isExpanded ? "side-nav--expanded" : ""}`}>
      <aside className={`side-nav__main`}>
        <div className={`side-nav__content ${isExpanded ? "py-2" : "py-3"} px-3`}>
          <div>
            <img
              className={`side-nav__logo-img ${!isExpanded && "side-nav__logo-img--hidden"} mb-2 mt-1`}
              src={logo}
              alt="Serendata logo"
            />
            <img
              className={`mb-2 logo-img ${isExpanded && "side-nav__logo-img--hidden"}`}
              src={miniLogo}
              alt="Serendata logo"
            />
          </div>

          <DashboardNavItems isExpanded={isExpanded} />
          <Hr style={{ width: "100%" }} colour={Colours.GRAY_400} />
          <IF condition={!!projectId}>{ProjectNavItems(isExpanded)}</IF>
          {/* {isAIChatEnabled && (
            <div className="side-nav__ai-chat">
              <Button size={Enums.UiSizes.MD} className={`side-nav__button`}>
                <Icon symbol={IconSymbols.MessageFilled} /> AI Chat
              </Button>
            </div>
          )} */}
        </div>
        <div className="side-nav__footer">
          <Hr style={{ width: "100%" }} colour={Colours.GRAY_400} />
          <div className="side-nav__toggle">
            <Button
              aria-label="Toggle Sidebar"
              type={ButtonTypes.LINK}
              className="side-nav__toggle-button p-0"
              onClick={() => {
                const newState = !isExpanded;
                localStorage.setItem("insight-sidenav-expanded", String(newState));
                props.onExpandedToggle(newState);
                setIsExpanded(newState);
              }}
            >
              <Icon symbol={isExpanded ? IconSymbols.ArrowLeftCircle : IconSymbols.ArrowRightCircle} />
              {isExpanded ? (
                <span className={`side-nav__item-label speed-2 ${Animations.SLIDE_IN_UP}`}>Collapse</span>
              ) : (
                ""
              )}
            </Button>
          </div>
          <SettingsNavigation isNavExpanded={isExpanded} />
        </div>
      </aside>
    </div>
  );
});
